<template>
    <div>
        <span v-if="currentWallet" class="btn-wallet">
            <small>
                <template v-if="isUpdatingBalance">
                    ***
                </template>
                <template v-else>
                    {{ balance }}
                </template>
            </small>
            {{ cTrimmedWalletAddress }}
        </span>
        <button v-else @click="connectWallet()" class="btn-wallet">CONNECT WALLET</button>
    </div>
</template>
<script>
import axios from "axios";
export default {
    data() {
        return {
            balance: null,
            currentWallet: null,
            isUpdatingBalance: false
        };
    },
    async created() {
        this.currentWallet = await this.getCurrentWalletConnected();
        this.updateWalletBalance();

        window.ethereum.on("accountsChanged", this.updateConnectedWallet);
    },
    watch: {
        currentWallet() {
            this.$emit("walletUpdated", this.currentWallet);
            console.log("walletUpdated", this.currentWallet);
        }
    },
    computed: {
        cTrimmedWalletAddress() {
            let walletAddres = "";
            if (this.currentWallet !== null) {
                const addressFirstChunk = this.currentWallet.slice(0, 5);
                const addressLastChunk = this.currentWallet.slice(-4);
                walletAddres = `${addressFirstChunk}...${addressLastChunk}`;
            }

            return walletAddres;
        }
    },
    methods: {
        updateConnectedWallet(accounts) {
            this.currentWallet = accounts[0] ?? null;
            if (this.currentWallet) {
                this.updateWalletBalance();
            }
        },

        async updateWalletBalance() {
            if (this.currentWallet) {
                this.isUpdatingBalance = true;
                const balanceResponse = await axios.get(`api/walletBalance?wallet=${this.currentWallet}`);
                this.balance = balanceResponse.data?.balance ?? null;
                this.isUpdatingBalance = false;
            }
        },

        async connectWallet() {
            if (window.ethereum) {
                const addressArray = await window.ethereum.request({
                    method: "eth_requestAccounts"
                });

                this.currentWallet = addressArray[0];
                const balanceResponse = await axios.get(`api/walletBalance?wallet=${this.currentWallet}`);
                this.balance = balanceResponse.data?.balance ?? null;
            }
        },

        async getCurrentWalletConnected() {
            let currentWallet = null;

            const addressesArray = await window.ethereum.request({
                method: "eth_accounts"
            });

            if (window.ethereum) {
                if (addressesArray.length > 0) {
                    currentWallet = addressesArray[0];
                }
            }

            return currentWallet;
        }
    }
};
</script>
